module.exports = __webpack_public_path__ + "img/数据资料ico.223f9158.png";